import React from "react";
import { Link } from "react-router-dom";
import { CONTACT } from "../constants/copy";
import { FaInstagram, FaFacebookF, FaYoutube } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="relative bg-weddmac-dark text-white overflow-hidden">
      {/* Top accent line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-weddmac-gold/40 to-transparent" />

      <div className="max-w-6xl mx-auto px-6 sm:px-8 md:px-10 lg:px-12 xl:px-16 py-14 sm:py-16 lg:py-20">
        {/* Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12 lg:gap-16 items-end">
          
          {/* Contact */}
          <div className="md:col-span-2 text-center md:text-left">
            <h2 className="font-inria font-light text-2xl sm:text-3xl md:text-4xl tracking-tight mb-5">
              {CONTACT.heading}
            </h2>

            <p className="font-inria font-light text-lg sm:text-xl md:text-2xl text-white/90 hover:text-weddmac-gold transition-colors">
              <a
                href={`tel:${CONTACT.mobile.replace(/[^\d+]/g, "")}`}
                className="focus:outline-none focus:ring-2 focus:ring-weddmac-gold/50 rounded"
              >
                {CONTACT.mobile}
              </a>
            </p>

            <p className="mt-2 font-inria font-light text-lg sm:text-xl md:text-2xl text-white/90 hover:text-weddmac-gold transition-colors break-all">
              <a
                href={`mailto:${(CONTACT.email.split(" :- ")[1] || CONTACT.email).trim()}`}
                className="focus:outline-none focus:ring-2 focus:ring-weddmac-gold/50 rounded"
              >
                {CONTACT.email}
              </a>
            </p>
          </div>

          {/* Logo / Social / Admin */}
          <div className="flex flex-col items-center md:items-end gap-4 text-center md:text-right">
            
            {/* Logo */}
            <div className="flex justify-center mb-6">
              <img
                src="/webitelogo.png"
                alt="Weddmac Photography Logo"
                className="w-48 sm:w-56 md:w-64 lg:w-72 opacity-95"
              />
            </div>

            {/* Social Media Icons */}
            <div className="flex gap-5 items-center justify-center md:justify-end">
              <a
                href="https://www.instagram.com/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="text-white/60 hover:text-weddmac-gold transition-colors text-xl"
              >
                <FaInstagram />
              </a>

              <a
                href="https://www.facebook.com/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="text-white/60 hover:text-weddmac-gold transition-colors text-xl"
              >
                <FaFacebookF />
              </a>

              <a
                href="https://www.youtube.com/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                className="text-white/60 hover:text-weddmac-gold transition-colors text-xl"
              >
                <FaYoutube />
              </a>
            </div>

            {/* Admin link */}
            <Link
              to="/admin"
              className="font-inter text-sm text-white/40 hover:text-weddmac-gold transition-colors"
            >
              Add images →
            </Link>

            {/* Copyright */}
            <p className="font-inter text-xs sm:text-sm text-white/50 tracking-widest uppercase">
              {CONTACT.copyright}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
